export const hero = {
  title: "La escuela en la naturaleza donde niñas y niños crecen felices y con seguridad",
  subtitle: "Una escuela con un máximo de 80 niñas y niños en Gondomar: inspiración Montessori, una persona docente por cada 10-12 peques, tres lenguas que conviven a diario con el inglés como principal, y acreditación NEASC.",
  bookVisit: "Reservar visita",
  discoverGandara: "Descubre Gándara"
};
